import { useAppDispatch } from '@/state/store';
import { useState } from 'react';
import { parse } from 'csv-parse/lib/sync';

import styles from './styles.module.scss';
import { createCardThunk } from '@/state/features/app';

interface DeckCSVUploadProps {
    deck_id: string;
}

export default function DeckCSVUpload({ deck_id }: DeckCSVUploadProps) {
    const [cardToUpload, setCardToUpload] = useState<{ front: string; back: string }[]>([]);
    const [uploadedCards, setUploadedCards] = useState(0);
    const dispatch = useAppDispatch();

    function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
        const file = event.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const csvText = e.target?.result as string;
                const records = parse(csvText, {
                    columns: true,
                    skip_empty_lines: true,
                    trim: true,
                });

                const cards = records
                    .filter((record: any) => record.front && record.back)
                    .map((record: any) => ({
                        front: record.front,
                        back: record.back,
                    }));

                if (cards.length === 0) {
                    console.error('CSV must contain "front" and "back" columns with data');
                    return;
                }

                setCardToUpload(cards);
            } catch (error) {
                console.error('Error parsing CSV:', error);
            }
        };

        reader.readAsText(file);
    }

    async function uploadCards() {
        console.log('Uploading cards:', cardToUpload);

        setUploadedCards(0);
        for (const card of cardToUpload) {
            try {
                await dispatch(
                    createCardThunk({
                        front: card.front,
                        back: card.back,
                        deck_id: deck_id,
                    }),
                );
                setUploadedCards((prev) => prev + 1);
            } catch (error) {
                console.error('Failed to upload card:', error);
            }
        }
    }

    console.log('Card to upload:', cardToUpload);
    return (
        <div className={styles.CSVUpload}>
            <input type="file" accept=".csv" onChange={handleFileChange} />
            <button onClick={uploadCards}>Upload Deck CSV</button>
            {cardToUpload.length > 0 && (
                <div className={styles.uploadStatus}>
                    <p>
                        Total Cards: {cardToUpload.length} | Uploaded: {uploadedCards}
                    </p>
                </div>
            )}
        </div>
    );
}
